<mat-card appearance="outlined">
    <mat-card-title [innerText]="applyStrings( dialogWait.title | translate, (dialogWait.titleReplace || []) )"></mat-card-title>
    <mat-card-content>
        <span class="text" [innerText] = "dialogWait.message | translate"></span>
        <br>
        <div align="center">
            <mat-spinner></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>